<div>


        <div style="max-height: 50vh; overflow-y: auto" [ngSwitch]="edits_materiali.length > 0">

            <div style="display: flex">
                <div style="flex-grow: 1">
                    <h3>Lista Materiali</h3>
                </div>
                <div style="margin-left: 2em">
                    <div class="p-inputgroup">
                        <p-dropdown styleClass="form_select_mid ddgroupright" appendTo="body" [options]='optionsMateriali' [(ngModel)]="currentOptionMateriali" placeholder="modello dispositivo"></p-dropdown>
                        <button pButton type="button" icon="pi pi-plus" pTooltip="Aggiungi materiali alla movimentazione" tooltipPosition="top"
                            class="font-['Poppins']"
                            style="background-color:#ffffff; color: cadetblue; border-color: cadetblue; font-size: 13px;" label="Aggiungi"
                            [disabled]="currentOptionMateriali == null"
                            (click)="addToMaterialsList()"
                        ></button>

                    </div>
                </div>
            </div>

            <div class="warning" *ngSwitchCase="false">nessuna discrepanza: spedizione come previsto</div>

            <p-table styleClass="p-datatable-sm" [value]="edits_materiali" dataKey="id"
                     responsiveLayout="stack" *ngSwitchCase="true">

                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="id">
                                <div class="flex justify-content-between align-items-center">
                                    NMU
                                </div>
                            </th>
                            <th>
                                <div class="flex justify-content-between align-items-center">
                                    descrizione
                                </div>
                            </th>
                            <th>
                                <div class="flex justify-content-between align-items-center">
                                    previsti
                                </div>
                            </th>
                            <th>
                                <div class="flex justify-content-between align-items-center">
                                    effettivi
                                </div>
                            </th>
                            <th>
                                <div class="flex justify-content-between align-items-center">
                                    differenza
                                </div>
                            </th>
                            <th>
                                <div class="flex justify-content-between align-items-center">

                                </div>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-row>
                        <tr>

                            <td><span class="text-lowercase">{{ row.modello.nmu }}</span></td>
                            <td style="width: 100%"><span class="text-lowercase">{{ row.modello.descrizione }}</span></td>
                            <td><span class="text-lowercase">
                                {{previstiById[row.modello.id] ?? 0}}
                            </span></td>
                            <td>
                                <p-inputNumber [(ngModel)]="row.qt" [showButtons]="true" buttonLayout="horizontal" inputId="horizontal" [step]="1" [min]="0" [max]="previstiById[row.modello.id]" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" [size]="5">
                                </p-inputNumber>
                            </td>
                            <td>
                                {{row.qt - (previstiById[row.modello.id] ?? 0)}}
                            </td>
                            <td><span class="text-lowercase">
                                <button pButton type="button" icon="pi pi-trash" pTooltip="Rimuovi" tooltipPosition="top"
                                    class="font-['Poppins']"
                                    label="Elimina"
                                    (click)="removeFromMaterialsList(row.modello.id)"
                                ></button>
                            </span></td>

                        </tr>
                    </ng-template>
                </p-table>


            </div>

        <p-divider type="solid"></p-divider>

        <div class="dialog_controls">

            <p-button icon="pi pi-times" label="Annulla" class="p-button-text mr-1 row_button" (click)="onActivityCompleted(false)"></p-button>
            <p-button icon="pi pi-check" label="Conferma" class="p-button-text ml-100 row_button" styleClass="p-button-success" (click)="onActivityCompleted(true)" [disabled]="!hasValidForm"></p-button>
        </div>
</div>